import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { useParams } from "react-router-dom";
import { fetchProductById } from "../../redux/state/productsReduser/product.fetch";
import { selectProductsDetails } from "../../redux/state/productsReduser/product.selectors";

function ProductDetails() {
  const { productId } = useParams();
  const dispatch = useDispatch();
  const product = useSelector(selectProductsDetails);


  useEffect(() => {
    dispatch(fetchProductById(productId));
  }, [dispatch, productId]);

  return <div>{product && <h1>{product.name}</h1>}</div>;
}

export default ProductDetails;
